<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('QiYeZhanShi')">企业展示</a></li> -->
                        <li><a href="javascript:void(0);" @click.stop="goTo('FaZhanLiCheng')">发展历程</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">资质荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ChengGongAnLi')">典型案例</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('ChanPinJiYingYongShiPin')">产品及应用视频</a></li> -->
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="contnet">
                        <p v-html="webDescription"></p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { GuanYuKaiNa } from "../request/api"; // 导入接口


export default {
    name: 'Home',
    data() {
        return {
            title: '发展历程',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            webTitle:'',
            webDescription:'',
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.FaZhanLiCheng_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        FaZhanLiCheng_data(){ //企业文化
            GuanYuKaiNa({
            }).then((res) => {
                console.log( res );
                this.webTitle = res.rows[6].webTitle;
                this.webDescription = res.rows[6].webDescription;
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FaZhanLiCheng.vue